module.exports = __webpack_public_path__ + "static/media/oy_1.4cfbc072.ogg";